import React, { useState } from "react";
import { Link } from "react-router-dom";

const SPC10MMDetail = () => {
  // Initialize data for the product
  const productData = {
    names: ["FREEZE", "WAMP", "SQUEEZE", "QUEST","GRAND", "BROKE"],
    
    categories: ["Tiger 6mm", "Tiger 6mm", "Tiger 6mm", "Tiger 6mm"],
    // text: [
    //   "SPC Flooring",
    //   "Durable Laminate",
    //   "Luxury Vinyl Plank",
    //   "Hybrid Flooring",
    //   "Engineered Wood Plank"
    // ]
  };

  // Array of 5 color options
  const colorOptions = [
    "https://www.bearfoot.ie/assets/waterproof-spc/tiger-6mm/republic-tiger/free/Freeze_001__FocusFillWzU2MCwzOTIsInkiLDg0XQ.jpg",
    "https://www.bearfoot.ie/assets/waterproof-spc/tiger-6mm/republic-tiger/wamp/Wand_001__FocusFillWzU2MCwzOTIsInkiLDg0XQ.jpg",
    "https://www.bearfoot.ie/assets/waterproof-spc/tiger-6mm/republic-tiger/squeeze/Squeeze_001__FocusFillWzU2MCwzOTIsInkiLDg0XQ.jpg",
    "https://www.bearfoot.ie/assets/waterproof-spc/tiger-6mm/republic-tiger/quest/Quest_001__FocusFillWzU2MCwzOTIsInkiLDg0XQ.jpg",
    "https://www.bearfoot.ie/assets/waterproof-spc/tiger-6mm/republic-tiger/grand/Grand_001__FocusFillWzU2MCwzOTIsInkiLDg0XQ.jpg",
    "https://www.bearfoot.ie/assets/waterproof-spc/tiger-6mm/republic-tiger/broke/Broke_001__FocusFillWzU2MCwzOTIsInkiLDg0XQ.jpg"
   
  ];

  const [currentImage, setCurrentImage] = useState(colorOptions[0]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleColorClick = (colorImage, idx) => {
    setCurrentImage(colorImage);
    setCurrentIndex(idx);
  };

  return (
    <div className="product-detail">
      <Link to="/10mm_wps" className="back-link">
        Back
      </Link>
      <div className="product-main">
        <img
          className="main-product-image"
          src={currentImage}
          alt={productData.names[currentIndex]}
          style={{
            width: "300px",
            height: "300px",
            border: "1px solid #ddd",
            marginBottom: "10px",
          }}
        />
        <div className="product-info">
          <h2>{productData.names[currentIndex]}</h2>
          {/* <strong>{productData.descriptions[currentIndex]}</strong> */}
          <h5>Category: {productData.categories[currentIndex]}</h5>
          {/* <p>{productData.text[currentIndex]}</p> */}

          <div className="colors">
            {colorOptions.map((colorImage, idx) => (
              <div
                key={idx}
                className="color-swatch"
                onClick={() => handleColorClick(colorImage, idx)}
                style={{
                  cursor: "pointer",
                  display: "inline-block",
                  margin: "2px",
                }}
              >
                <img
                  src={colorImage}
                  alt={`Color Option ${idx + 1}`}
                  style={{
                    width: "70px",
                    height: "70px",
                    border: currentIndex === idx ? "2px solid blue" : "2px solid #ddd",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SPC10MMDetail;
